export const MIGRATION_SUNSET_DATE = new Date('2026-07-31T23:59:59-06:00');
export const MIGRATION_SESSION_KEY = 'vinsyt_migration_popup_dismissed';
export const IS_MIGRATION_POPUP_ENABLED = process.env.REACT_APP_SHOW_MIGRATION_POPUP === 'true';

export const getMigrationCountdown = (targetDate = MIGRATION_SUNSET_DATE) => {
  const now = new Date();
  const diff = targetDate.getTime() - now.getTime();

  if (diff <= 0) {
    return {
      isExpired: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalMs: 0
    };
  }

  const totalSeconds = Math.floor(diff / 1000);

  return {
    isExpired: false,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    totalMs: diff
  };
};

export const formatSunsetDate = (date = MIGRATION_SUNSET_DATE) =>
  date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'America/Chicago'
  });
